import type { LocationQuery } from 'vue-router';
import * as maptilersdk from '@maptiler/sdk';

export default function useMapFunctions() {
  /********************
   * COMPOSITIONS      *
   ********************/
  const route = useRoute();

  /********************
   * FUNCTIONS         *
   ********************/
  function getBoundsFromQueryString(query: LocationQuery | null = null): maptilersdk.LngLatBounds | null {
    if (query === null) {
      query = route.query;
    }

    if ('area' in query && query.area) {
      const area = (query.area as string).split(',').map(parseFloat);
      return new maptilersdk.LngLatBounds([area[0], area[1]], [area[2], area[3]]);
    }

    return null;
  }

  return {
    getBoundsFromQueryString,
  };
}
